import { ref } from "vue";
import { defineStore } from "pinia";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

type MessagesAnalysedItem = {
  period: string;
  total: number;
};

export const useMessagesAnalysedStore = defineStore("messagesAnalysed", () => {
  const messagesAnalysed = ref<MessagesAnalysedItem[]>([]);

  const getMessagesAnalysed = async ({
    globalOrganisationID,
    params,
  }: {
    globalOrganisationID: string;
    params: Record<string, string>;
  }): Promise<void> => {
    const filterParams = new URLSearchParams(params);
    const res = await $http.get(
      `${getApiClientUrl()}/v3/pt/history/globalOrganisationID/${globalOrganisationID}/stats/messages?${filterParams.toString()}`,
    );
    messagesAnalysed.value = res.data.data;
  };

  return {
    messagesAnalysed,
    getMessagesAnalysed,
  };
});
